import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import {filterDropdown_template} from "../../../common/js/vnKnockoutJsTemplates/filterDropdown_template";

declare var ko: any;
declare var page: any;

export class goalEdit_template extends vnTemplate{

    public brandsFilter: filterDropdown_template;
    public initiativesFilter: filterDropdown_template;
    public monthsFilter: filterDropdown_template;
    public groupsFilter: filterDropdown_template;

    protected getTemplateHtml(): string{

        return `
                   
            <div class="form-header" data-bind="with: goal">
                <input type="hidden">
                
                <!-- ko ifnot: $parent.idGoal() -->
                <h3 class="form-title icon i-goal">Add Goal</h3>
                <!-- /ko -->
                
                <!-- ko if: $parent.idGoal() -->
                <h3 class="form-title icon i-goal" data-bind="text: brand.name + ' | ' + group.name  + ' | ' + initiative.name + ' | ' + displayMonth + ' ' + year"></h3>
                <!-- /ko -->

                <button data-bind="event: { click: $parent.onClickCancel }" class="close-button icon i-close" type="button"></button>
            </div>
           
            
            <div class="form-body full-width" id="goals-results">
                <table class="list-action goal-page" >
                    <thead>
                        <tr>
                            <th style="width: 3rem;"></th>
                            <!-- ko foreach: pastGoals -->
                                <th><button class="btn" type="button" data-bind="text: displayDate, css: {'is-selected': id == $parent.idGoal() }, event: { click: $parent.onEditSelectedGoal }"></button></th>
                            <!-- /ko -->
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><span class="icon i-article-2"></span></td>
                            <!-- ko foreach: pastGoals -->
                                <td><span data-bind="text: articleCount"></span></td>
                            <!-- /ko -->
                        </tr>
                        <tr>
                            <td><span class="icon i-user"></span></td>
                            <!-- ko foreach: pastGoals -->
                                <td><span data-bind="text: sessionsPerArticle"></span></td>
                            <!-- /ko -->
                        </tr>
                        <tr>
                            <td><span class="icon i-cost"></span></td>
                            <!-- ko foreach: pastGoals -->
                                <td><span data-bind="text: costPerArticle"></span></td>
                            <!-- /ko -->
                        </tr>
                        <tr>
                            <td><span>Copy From</span></td>
                            <!-- ko foreach: pastGoals -->
                                <td><button class="btn only-icon icon i-insert" type="button" data-bind="click: $parent.onApplyGoalValues"></button></td>
                            <!-- /ko -->
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <div class="w-form-body backg">
                <div class="form-body full-width border">
                    <strong class="form-sub-title" data-bind="text: yearMonth"></strong>
                </div>
            </div>
            
            <div id="view-results">
  
                <div class="w-form-body">
                    <div class="form-body border">
                        <div class="form-group row">
                            <label class="form-label icon i-brand">Brand</label>
                             ${ this.brandsFilter.getHtmlBuild() }
                        </div>
                        <div class="form-group row">
                            <label class="form-label icon i-label">Initiative</label>
                            ${ this.initiativesFilter.getHtmlBuild() }
                        </div>
                        <div class="form-group row">
                            <label class="form-label icon i-group">Network Category Group</label>
                            ${ this.groupsFilter.getHtmlBuild() }
                        </div>
                        <div class="form-group row">
                            <label class="form-label icon i-month">Month/Year</label>
                            <div class="row">
                                ${ this.monthsFilter.getHtmlBuild() }
                                <div>
                                    <label class="form-label" for="year">Year</label>
                                    <div class="w-input" data-bind="with: goal">
                                        <input type="text" name="year" min="2021" id="year" class="input-text num" data-bind="value: year, event: { change: $parent.onChangeYear, keyup: $parent.onStateChange }">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    
                    <div class="form-body border" data-bind="with: goal">

                        <div class="form-group row">
                            <label class="form-label icon i-article-2">Article / Day</label>
                            <div class="w-input">
                                <input type="text" min="0" name="articleCount" id="articleCount" class="input-text align-right " data-bind="value: articleCountDisplay, event: { change: $parent.onChangeCostAllocation , keyup: $parent.onStateChange }">
                            </div>
                        </div>  
                        <div class="form-group row">
                            <label class="form-label icon i-user">Sessions Per Article</label>
                            <div class="w-input">
                                <input type="text" min="0" name="sessionsPerArticle" id="sessionsPerArticle" class="input-text align-right " data-bind="value: sessionsPerArticle, event: { keyup: $parent.onStateChange }">
                            </div>
                        </div>  
                        <div class="form-group row">
                            <label class="form-label icon i-cost">Cost Per Article</label>
                            <div class="w-input">
                                <input type="text" min="0" name="costPerArticle" id="costPerArticle" disabled  class="input-text align-right  read-only" data-bind="value: costPerArticle, event: { keyup: $parent.onStateChange }">
                            </div>
                        </div>            
                    </div>   
                </div>
                
                <div class="w-form-body backg">
                    <div class="form-body full-width border cost-allocation w-justify">
                        <div class="w-left">
                            <button data-bind="click: onClickAddCostAllocation" class="btn highlight icon i-add" type="button">Add Cost</button>
                        </div>
                        <div class="w-center">
                            <strong class="form-sub-title">Cost allocation</strong>
                        </div>
                        <div class="w-right">
                        
                        </div>
                    </div>
                </div>

                <table class="list-action">
                  
                    <tbody data-bind="foreach: costAllocations">
                        <tr>
                             <td>
                                <div class="form-group row">
                                    <label class="form-label">name</label>
                                    <div class="w-input wide">
                                        <input type="text" class="input-text" data-bind="value: name, event: { keyup: $parent.onStateChange }">
                                    </div>
                                </div>
                            </td>   
                            <td>
                                <div class="form-group row">
                                    <label class="form-label">Amount</label>
                                    <div class="w-input">
                                        <input type="text" min="0" class="input-text num" data-bind="value: amount, event: { change: $parent.onChangeCostAllocation,  keyup: $parent.onStateChange }">
                                    </div>
                                </div>
                            </td>
                            <td class="no-border">
                                <div class="form-group form-check-inline">     
                                    <input type="checkbox" data-bind="checked: noNbrOfArticlesLimit, attr: {id: 'noNbrOfArticlesLimit_' + order}">
                                    <label class="form-label icon i-check" data-bind="attr: {for: 'noNbrOfArticlesLimit_' + order}">Fixed Cost</label>
                                </div>
                            </td>
                            <td>
                                <div class="form-group row" data-bind="css: { 'is-disable' : noNbrOfArticlesLimit}">
                                    <label class="form-label">Number Of Article</label>
                                    <div class="w-input" >
                                        <input type="text" min="0" class="input-text num" data-bind="value: nbrArticles, event: { change: $parent.onChangeCostAllocation,  keyup: $parent.onStateChange }">
                                        
                                    </div>
                                                                   
                                </div>
                            </td>
                            <td class="align-right">
                                <button class="btn only-icon icon i-delete" type="button" data-bind="event: {click: $parent.onClickDeleteCostAllocation}"></button>
                            </td>  
                        </tr>  
                    </tbody> 
                </table> 
                           
                
                <div class="form-footer goal-option ">
                    <button class="btn" type="button" data-bind="click: onClickCancel">Cancel</button>
                    <button class="btn highlight" type="button" data-bind="click: onClickSave">Save</button>
                    <button class="btn highlight" type="button" data-bind="click: onClickSaveAndStay">Save and Stay</button>
                                        
                    <input type="checkbox" id="expend_1" class="expend-input">
                    <label for="expend_1" class="expend-label icon i-dropdown-simple">Bulk Month Edit</label>
                    
                    <div class="w-form-body">
                        <div class="form-body full-width">
                        
                            <div class="form-group row month">
                                <label class="form-label icon i-month">For the next</label>
                                <div class="w-input after-text-month is-activated">
                                    <input type="text" min="0" class="input-text align-right" data-bind="value: autoFillGoalsNumber">
                                </div>
                            </div>    
                        
                            <div class="form-group row">
                                <div class="flex-start">
                                    <input type="checkbox" id="article" data-bind="checked: autoFillArticleCountActive">
                                    <label for="article" class="form-label icon i-check"></label>  
                                    <label class="form-label icon i-article-2">Article / Day</label>
                                    
                                </div>
                                <div class="w-input margin-right" data-bind="css: { 'is-activated' : autoFillArticleCountActive}">
                                    <input type="text" min="0"  class="input-text align-right" data-bind="value: autoFillArticleCountValue">
                                </div>
                            </div>
                            
                            <div class="form-group row">
                                <div class="flex-start">
                                    <input type="checkbox" id="session" data-bind="checked: autoFillSessionPerArticleActive">
                                    <label for="session" class="form-label icon i-check"></label>
                                    <label class="form-label icon i-user">Sessions Per Article</label>  
                                </div>
                                <div class="w-input" data-bind="css: { 'is-activated' : autoFillSessionPerArticleActive}">
                                    <input type="text" min="0"  class="input-text align-right" data-bind="value: autoFillSessionPerArticleValue">
                                </div>
                                <select name="" id="" data-bind="options: valueTypes, optionsText: 'name', optionsValue: 'id', value: autoFillSessionPerArticleSelectedType"></select>
                            </div>
                        
                            <div class="form-group row" style="padding-top: .5rem">
                                <div class="flex-start">
                                    <input type="checkbox" id="allocated" data-bind="checked: copyAllocatedCost">
                                    <label for="allocated" class="form-label icon i-check"></label> 
                                    <label class="form-label icon i-cost">Copy Allocated Cost</label>
                                </div> 
                            </div>          
                        </div> 
                    </div>            
                </div>
            </div>
            `;
    }


    protected initPartial() {

        this.brandsFilter = new filterDropdown_template("brandsFilter", this.getTemplateViewModel(), this.caller);
        this.initiativesFilter = new filterDropdown_template("initiativesFilter", this.getTemplateViewModel(), this.caller);
        this.groupsFilter = new filterDropdown_template("groupsFilter", this.getTemplateViewModel(), this.caller);
        this.monthsFilter = new filterDropdown_template("monthsFilter", this.getTemplateViewModel(), this.caller);
    }

    /**
     *
     * @protected
     */
    protected getTemplateName(): string {
        return "goalEdit_template";
    }

    protected getMainElementClasses(): Array<string> {

        return ["w-form", "w-form-large", "margin-top", "w-form-larger"];
    }

    protected buildViewModel(): any {

        let myself = this;
        return {
            idGoal: ko.observable(""),
            idGoalSelectedRedirection: ko.observable(null),
            goal: ko.observable(),
            hasStateChanged: ko.observable(false),
            costAllocations: ko.observableArray([]),
            costAllocationsToDelete: ko.observableArray([]),
            pastGoals: ko.observableArray([]),
            yearMonth: ko.observable(''),
            saveAndStay: ko.observable(false),
            autoFillGoalsNumber: ko.observable(null),
            autoFillArticleCountValue: ko.observable(null),
            autoFillArticleCountActive: ko.observable(false),
            autoFillSessionPerArticleValue: ko.observable(null),
            autoFillSessionPerArticleActive: ko.observable(false),
            autoFillSessionPerArticleSelectedType: ko.observable('percentage'),
            copyAllocatedCost: ko.observable(false),
            valueTypes: ko.observableArray([
                {id: 'percentage', name: '%'},
                {id: 'amount', name: 'int'}
            ]),
            onClickEdit: function () {
                myself.onClickEdit();
            },
            onClickSave: function (data, event) {
                myself.onClickSave();
            },
            onClickSaveAndStay: function (data, event) {
                myself.onClickSaveAndStay();
            },
            onClickCancel: function (data, event) {
                myself.onClickCancel();
            },
            onEditSelectedGoal: function (data, event) {
                myself.editSelectedGoal(data);
            },
            onClickAddCostAllocation:  function (data, event) {
                myself.onClickAddCostAllocation();
            },
            onClickDeleteCostAllocation: function (data, event) {
                myself.onClickDeleteCostAllocation(data);
            },
            onApplyGoalValues: function (data, event) {
                myself.onApplyGoalValues(data);
            },
            onChangeYear: function (data, event) {
                myself.onChangeYear();
            },
            onChangeCostAllocation: function (data, event) {
                myself.changeCostAllocationAmount();
            },
            onStateChange: function (data, event) {
                myself.onStateChange();
            }
        };
    }

    // implementation of base class [vnTemplate]
    public getViewModelForRequest(): Object {

        let goal = this.getGoal();

        return {
            idGoal: goal.id,
            year: goal.year,
            articleCount: goal.articleCount,
            sessionsPerArticle: goal.sessionsPerArticle,
            costPerArticle: goal.costPerArticle,
            costAllocations: this.getTemplateViewModel().costAllocations(),
            costAllocationsToDelete: this.getTemplateViewModel().costAllocationsToDelete(),
            month: this.monthsFilter.getTemplateViewModel().selectedOption(),
            idBrand: this.brandsFilter.getTemplateViewModel().selectedOption(),
            idInitiative: this.initiativesFilter.getTemplateViewModel().selectedOption(),
            idGroup: this.groupsFilter.getTemplateViewModel().selectedOption(),
            autoFillGoalsNumber: this.getTemplateViewModel().autoFillGoalsNumber(),
            autoFillArticleCount: {
                active: this.getTemplateViewModel().autoFillArticleCountActive(),
                value: this.getTemplateViewModel().autoFillArticleCountValue(),
            },
            autoFillSessionPerArticle: {
                active: this.getTemplateViewModel().autoFillSessionPerArticleActive(),
                value: this.getTemplateViewModel().autoFillSessionPerArticleValue(),
                type: this.getTemplateViewModel().autoFillSessionPerArticleSelectedType()
            },
            copyAllocatedCost: this.getTemplateViewModel().copyAllocatedCost(),
        }
    }

    public hasStateChanged(): boolean {
        return this.getTemplateViewModel().hasStateChanged();
    }

    public setStateAsChanged(): void {
        this.getTemplateViewModel().hasStateChanged(true);
    }

    public autofillStateChange(): void {

        if (this.getTemplateViewModel().autoFillGoalsNumber() != null) {

            this.setStateAsChanged();
        }
        if (this.getTemplateViewModel().autoFillArticleCountActive() != false) {

            this.setStateAsChanged();
        }
        if (this.getTemplateViewModel().autoFillSessionPerArticleActive() != false) {

            this.setStateAsChanged();
        }
        if (this.getTemplateViewModel().copyAllocatedCost() != false) {

            this.setStateAsChanged();
        }

    }

    protected onClickEdit(): void {

        page('/goals/edit/' + this.getTemplateViewModel().idGoal());
    }

    //
    // click on save button
    protected onClickSave(): void {

        if(this.validAutoFillFutureGoalsInput()) {

            this.unsetSaveAndStay();
            this.caller.saveEditGoal();
        }
    }

    protected onClickSaveAndStay(): void {

        if(this.validAutoFillFutureGoalsInput()) {

            this.setSaveAndStay();
            this.caller.saveEditGoal();

        }
    }

    public getSaveAndStay(): boolean {
        return this.getTemplateViewModel().saveAndStay();
    }

    public setSaveAndStay(): void {
        this.getTemplateViewModel().saveAndStay(true);
    }

    public unsetSaveAndStay(): void {
        this.getTemplateViewModel().saveAndStay(false);
    }

    //
    // click on cancel button
    protected onClickCancel(): void {

        this.caller.cancelEditGoal();
    }

    protected editSelectedGoal(data): void {

        this.autofillStateChange();

        if (!this.hasStateChanged()) {
            this.getTemplateViewModel().idGoalSelectedRedirection(data.id);
            this.caller.redirectToSelectedGoal();
        }

        // trigger the selection only the the targeted goal is different from the current one i'm on.
        if (data.id != this.getGoalId() && this.hasStateChanged()) {

            let saveConfirmation = confirm('You are about to leave with unsaved changes.  Do you want to proceed?');
            if (saveConfirmation == true) {
                this.getTemplateViewModel().idGoalSelectedRedirection(data.id);
                this.caller.redirectToSelectedGoal();
            }
        }
    }

    public isGoalRedirection(): boolean {

        return (this.getIdGoalRedirection() != null);
    }

    public getIdGoalRedirection(): number {

        return  this.getTemplateViewModel().idGoalSelectedRedirection();
    }

    // set default values on new cost allocation entry
    protected onClickAddCostAllocation(): void {

        let newAddedCostAllocationOrder = 1;

        if(this.getTemplateViewModel().costAllocations().length > 0) {

            let lastCostAllocation = this.getTemplateViewModel().costAllocations()[this.getTemplateViewModel().costAllocations().length - 1];
            let lastCostAllocationOrder = lastCostAllocation['order'];
            newAddedCostAllocationOrder = lastCostAllocationOrder + 1;

        }

        let costAllocation  = {
                "id": null,
                "name": "",
                "amount": null,
                "nbrArticles": null,
                "noNbrOfArticlesLimit": false,
                "order": newAddedCostAllocationOrder
            };

        let costAllocations = this.getTemplateViewModel().costAllocations();
        costAllocations.unshift(costAllocation);

        this.getTemplateViewModel().costAllocations(costAllocations);
    }

    public onClickDeleteCostAllocation(costAllocation: { id: number }): void {

        let costAllocations = this.getTemplateViewModel().costAllocations();
        let newCostAllocations = [];
        let costAllocationsToDelete = this.getTemplateViewModel().costAllocationsToDelete();

        costAllocations.forEach((ca) => {
            if (ca.id == costAllocation.id) {
                costAllocationsToDelete.push(costAllocation);
            } else {
                newCostAllocations.push(ca);
            }
        });

        this.getTemplateViewModel().costAllocations(newCostAllocations)
        this.getTemplateViewModel().costAllocationsToDelete(costAllocationsToDelete);
    }


    protected onApplyGoalValues(goalToApply: {articleCountDisplay: number, articleCount: number, costPerArticle: number, sessionsPerArticle: number, year: number, month: number}): void {

        let daysInMonth = new Date(goalToApply.year, goalToApply.month, 0).getDate();

        let goalModel = this.getTemplateViewModel().goal();
        this.setStateAsChanged();

        goalModel.articleCountDisplay = Math.round((goalToApply.articleCount / daysInMonth) * 100) / 100;
        goalModel.costPerArticle = goalToApply.costPerArticle;
        goalModel.sessionsPerArticle = goalToApply.sessionsPerArticle;

        this.getTemplateViewModel().goal(goalModel);
    }

    protected onChangeYear(): void {

        this.buildYearMonth();
    }

    public setGoal(goal): void {

        let daysInMonth = new Date(goal.year, goal.month, 0).getDate();

        goal.articleCount = ko.observable(goal.articleCount);

        goal.articleCountDisplay = ko.observable(Math.round((goal.articleCount() / daysInMonth) * 100) / 100);

        goal.articleCount = ko.computed(function() {
            return goal.articleCountDisplay() * daysInMonth;
        }, this);

        this.getTemplateViewModel().goal(goal);

        this.setCostAllocations(goal.costAllocations);
    }

    public setGoalId(goalId: number): void {
        this.getTemplateViewModel().idGoal(goalId);
    }

    public setCostAllocations(costAllocations): void {

        let costAllocationOrder  = 1;

        for(let costAllocation of costAllocations){

            if(costAllocation.nbrArticles == null){
                costAllocation['noNbrOfArticlesLimit'] = ko.observable(true);
            }else{
                costAllocation['noNbrOfArticlesLimit'] = ko.observable(false);
            }

            costAllocation['order'] = costAllocationOrder;
            costAllocationOrder = costAllocationOrder + 1;

        }

        this.getTemplateViewModel().costAllocations(costAllocations);
    }


    public getGoalId(): number {
        return this.getTemplateViewModel().idGoal();
    }

    public getGoalIdRedirection(): number {
        return  this.getTemplateViewModel().isGoalRedirection();
    }

    /**
     *
     * @param brands
     */
    public setBrands(brands: Array<{ id: number, name: string}>): void {

        this.brandsFilter.setOptions(brands);
        this.brandsFilter.setSelectedOption(this.getGoal().brand.id);
    }

    public setInitiatives(initiatives: Array<{ id: number, name: string}>) {
        this.initiativesFilter.setOptions(initiatives)
        this.initiativesFilter.setSelectedOption(this.getGoal().initiative.id);
    }

    public setGroups(groups: Array<{ id: number, name: string}>) {
        this.groupsFilter.setOptions(groups);
        this.groupsFilter.setSelectedOption(this.getGoal().group.id);
    }

    public setMonths(months: Array<{ id: number, name: string}>) {
        this.monthsFilter.setOptions(months);
        this.monthsFilter.setSelectedOption(this.getGoal().month);
    }

    public getGoal() {
        return this.getTemplateViewModel().goal();
    }

    protected onUpdateError(status, data): void {
        console.log('onUpdateError' + status);
    }

    public setPastGoals(goals:Array<object>): void {

        this.getTemplateViewModel().pastGoals(goals);
    }

    private changeCostAllocationAmount(): void {

        console.log(this.getTemplateViewModel().costAllocations());

        let goal = this.getGoal();

        let articleCount = goal.articleCount();
        let costAllocations = this.getTemplateViewModel().costAllocations();
        let totalArticlesCost = 0;

        costAllocations.forEach((costAllocation) => {

            if (costAllocation.amount != null && costAllocation.nbrArticles != null) {

                // computation of total cost articles  considering a collection of cost allocations.
                totalArticlesCost += (Math.ceil(articleCount/ costAllocation.nbrArticles)/articleCount) * costAllocation.amount ;
            }
        });

        goal.costPerArticle = Number(totalArticlesCost).toLocaleString('en-EG', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        });

       this.getTemplateViewModel().goal(goal);
    }

    private validAutoFillFutureGoalsInput() {

        let regexp = new RegExp('^[-]?[0-9]+(.[0-9]+)*$');

        let articleCountAutoFill = (this.getTemplateViewModel().autoFillArticleCountValue() !== null && this.getTemplateViewModel().autoFillArticleCountValue() != '') ? this.getTemplateViewModel().autoFillArticleCountValue() : null;
        let sessionPerArticleAutoFill = (this.getTemplateViewModel().autoFillSessionPerArticleValue() !== null && this.getTemplateViewModel().autoFillSessionPerArticleValue() != '') ? this.getTemplateViewModel().autoFillSessionPerArticleValue() : null;
        let goalsNumberAutoFill = (this.getTemplateViewModel().autoFillGoalsNumber() !== null && this.getTemplateViewModel().autoFillGoalsNumber() != '') ? this.getTemplateViewModel().autoFillGoalsNumber() : null;

        let articleCountAutoFillValuesLength = null;
        let sessionPerArticleAutoFillValuesLength = null;
        let goalsNumberAutoFillValuesLength = null;

        if (articleCountAutoFill != null) {


            if (!regexp.test(articleCountAutoFill)) {

                this.caller.notifyNotValidAutoFillField('Article / Day');
                return false;
            }

            articleCountAutoFillValuesLength = articleCountAutoFill.split(",").length;
        }

        if (sessionPerArticleAutoFill != null) {

            if (!regexp.test(sessionPerArticleAutoFill)) {

                this.caller.notifyNotValidAutoFillField('session Per Article');
                return false;
            }

            sessionPerArticleAutoFillValuesLength = sessionPerArticleAutoFill.split(",").length;
        }

        if (goalsNumberAutoFill != null) {

            if (!regexp.test(goalsNumberAutoFill)) {

                this.caller.notifyNotValidAutoFillField('goals Number');
                return false;
            }

            goalsNumberAutoFillValuesLength = goalsNumberAutoFill.split(",").length;
        }

        if(articleCountAutoFillValuesLength !== null && sessionPerArticleAutoFillValuesLength !== null && goalsNumberAutoFillValuesLength !== null){

            if(articleCountAutoFillValuesLength != sessionPerArticleAutoFillValuesLength || articleCountAutoFillValuesLength != goalsNumberAutoFillValuesLength || sessionPerArticleAutoFillValuesLength != goalsNumberAutoFillValuesLength){

                this.caller.notifyNotValidLength();
                return false;
            }
        }else if(articleCountAutoFillValuesLength !== null && sessionPerArticleAutoFillValuesLength !== null ){

            if(articleCountAutoFillValuesLength != sessionPerArticleAutoFillValuesLength){

                this.caller.notifyNotValidLength();
                return false;
            }
        }else if(articleCountAutoFillValuesLength !== null && goalsNumberAutoFillValuesLength !== null){

            if(articleCountAutoFillValuesLength != goalsNumberAutoFillValuesLength){

                this.caller.notifyNotValidLength();
                return false;
            }
        }else if(sessionPerArticleAutoFillValuesLength !== null && goalsNumberAutoFillValuesLength !== null){

            if(sessionPerArticleAutoFillValuesLength != goalsNumberAutoFillValuesLength){

                this.caller.notifyNotValidLength();
                return false;
            }
        }

        return true;

    }

    private onStateChange(): void {

        this.setStateAsChanged();
    }

    public getMonthsList(): Array<{ id: number, name: string }> {
        return this.monthsFilter.getTemplateViewModel().options();
    }

    public getSelectedMonth(): number {
        return this.monthsFilter.getTemplateViewModel().selectedOption();
    }

    public buildYearMonth(): void  {

        let monthName = '';
        let selectedMonth = this.getSelectedMonth();
        let monthsList = this.getMonthsList();
        monthsList.forEach((month) => {
            if (month.id == selectedMonth) {
                monthName = month.name;
            }
        });

        this.getTemplateViewModel().yearMonth(monthName + ' ' + this.getTemplateViewModel().goal().year);
    }

    public setYearMonth(year: number, month: string): void  {

        this.getTemplateViewModel().yearMonth(month + ' ' + year);
    }

    public daysInMonth(month,year) {
        return new Date(year, month, 0).getDate();
    }

}



// WEBPACK FOOTER //
// ./js/components/templates/goalEdit_template.ts